// extracted by mini-css-extract-plugin
export var downArrow = "_ae-0";
export var label = "_ae-1";
export var treatmentCard = "_ae-3";
export var upArrow = "_ae-2";